module.exports = __webpack_public_path__ + "static/media/asm6.daa5b9b8.jpg";